import { FullPageLoading } from "@assetwatch/ui";
import type { ReactNode } from "react";
import {
  isWorkAccessDeniedError,
  useWorkContextQuery,
} from "../queries/useWorkContextQuery";
import { WorkAccessDenied } from "./WorkAccessDenied";

/**
 * Resolves Work access before the app shell renders. A 403 from the Work
 * context endpoint means the user has no Work Role, so the shell is replaced by
 * the not-authorized screen. Any other failure (network, 5xx) is not an
 * authorization verdict and falls through to the layout's own error state.
 * Shares the `work-context` query with the scope provider, so there is one
 * request.
 */
export function WorkAccessGate({ children }: { children: ReactNode }) {
  const { error, isPending } = useWorkContextQuery();

  if (isPending) {
    return <FullPageLoading />;
  }

  if (isWorkAccessDeniedError(error)) {
    return <WorkAccessDenied />;
  }

  return <>{children}</>;
}
